export interface Farm {
  id: string;
  name: string;
  alternatename?: string;
  description: string;
  ownedby: string;
  buildings: Building[]; // Almeno un building richiesto
  parcels?: Parcel[];   
}

export interface Building {
  description: string; // Obbligatorio, descrizione della sede
  address?: Address;   
  contactpoints?: ContactPoint[]; 
}

export interface ContactPoint {
    name?: string; 
    surname?: string; 
    email?: string; 
    phone?: string;
  }

  export interface Address {
    nation?: string;
    city?: string;
    country?: string;
    zipcode?: string;
    street_address?: string;
    house_number?: string;
  }

  export interface Parcel {
    id: string;
    name: string;
    description?: string;
    area?: number;
    cultivation?: string;
  }

  export enum WeatherParameter {
    AirHumidity = "Air humidity",
    AirPressure = "Air pressure",
    AirTemperature = "Air temperature",
    LeafWetness = "Leaf wetness",
    Rainfall = "Rainfall",
    SoilHumidity = "Soil humidity",
    SoilTemperature = "Soil temperature",
    SolarRadiation = "Solar radiation",
    WindDirection = "Wind direction",
    WindGusts = "Wind gusts",
    WindSpeed = "Wind speed"
  }